const options = {
    Membership: [
        { name: 'Birthday', value: 0 },
        { name: 'Wedding Anniversary', value: 1 },
        { name: 'First Timer Welcome Message', value: 2 },
        { name: 'New Convert Welcome Message', value: 3 },
        { name: 'Default Welcome Message', value: 4 },
        { name: 'Membership Information Update Message', value: 5 },
        { name: 'Meeting Absentee Message', value: 6 }
    ],
    Sms: [
        { name: 'Sms', value: 0 },
        { name: 'Email', value: 1 },
        { name: 'Voice', value: 2 },
    ]

}
export default options;